import React, { useState, useEffect, useRef } from "react";
import { useForm } from "react-hook-form";
import { Button, MultiSelect as MultiSelectUntyped } from "../../primary";
import { CANCEL_ID, CANCEL_BTN, SUBMIT_ID, SAVE_BTN } from "../../../constants";
import styles from "./assign.module.scss";
import { Modal } from "../../secondary";
import { getUniqueListBy } from "../../../utils";
import type { KeyValueOption, ProductFamilyOption, ProductCategoryListData, ApiEnvelope } from "../../../features/product-selector";
import type { ProductFamilyFilter } from "../../../features/custom-forms";

interface ProductFamilyCodeOption extends ProductFamilyOption {
    valueCode: string;
}

interface MultiSelectHandle {
    resetSelectedValues: (mode?: "all" | "empty") => void;
    state: { selectedValues: KeyValueOption[] };
}

const MultiSelect = MultiSelectUntyped as unknown as React.ComponentType<{
    id?: string;
    name?: string;
    label?: React.ReactNode;
    classes?: Record<string, string>;
    optionValue: KeyValueOption[];
    displayValue?: string;
    showCheckbox?: boolean;
    onSelect?: (list: KeyValueOption[]) => void;
    onRemove?: (list: KeyValueOption[]) => void;
    defaultValue?: KeyValueOption[];
    validator?: (handle: MultiSelectHandle) => void;
    closeOnSelect?: boolean;
}>;

interface AddFamilyProps {
    modalOpen: boolean;
    modalClose: () => void;
    getFamilyCode: (familyCodes: string[], index: number, pIndex: number, filter: ProductFamilyFilter) => void;
    index: number;
    productCategoryList?: ApiEnvelope<ProductCategoryListData>;
    pIndex: number;
    defaultValue?: ProductFamilyFilter;
    productFamily?: string[];
}

export const AddFamily: React.FC<AddFamilyProps> = ({
    modalOpen,
    modalClose,
    getFamilyCode,
    index,
    productCategoryList,
    pIndex,
    defaultValue,
    productFamily,
}) => {
    const { reset } = useForm();
    const productDiv = useRef<MultiSelectHandle | null>(null);
    const productCate = useRef<MultiSelectHandle | null>(null);
    const productFam = useRef<MultiSelectHandle | null>(null);
    const [productCat, setProductCat] = useState<KeyValueOption[]>([]);
    const [productFamilyCode, setProductFamilyCode] = useState<ProductFamilyCodeOption[]>([]);
    const [productFilter, setProdcutFilter] = useState<Partial<ProductFamilyFilter>>({});
    const [defaultFamily, setDefaultFamily] = useState<ProductFamilyCodeOption[]>([]);
    const [defaultDivision, setDefaultDivision] = useState<KeyValueOption[]>([]);
    const [productDivision, setProductDivision] = useState<KeyValueOption[]>([]);
    const [defaultProductCategoryDesc, setDefaultProductCategoryDesc] = useState<KeyValueOption[]>(
        []
    );

    useEffect(() => {
        setProductDivision(productCategoryList?.data?.division ?? []);
        let category: KeyValueOption[] = [];
        defaultValue?.division?.map((item) => {//NOSONAR
            const categoryDesc = productCategoryList?.data?.productCategoryDesc?.find(
                (x) => x?.key === item
            );
            if ((categoryDesc?.value?.length ?? 0) > 0) {
                category = [...category, ...(categoryDesc?.value ?? [])];//NOSONAR
            }
        });//NOSONAR
        if (category?.length > 0) {
            Array.isArray(category) &&
                category.length > 0 &&
                category.sort((a, b) => (a.value > b.value ? 1 : -1));
            setProductCat(category);
        }
        let familyCode: ProductFamilyCodeOption[] = [];
        defaultValue?.productCategoryDesc?.map((item) => {//NOSONAR
            const productFamilCode = productCategoryList?.data?.productFamilyDesc?.find(
                (x) => x?.key === item
            );
            let codeDesc: ProductFamilyCodeOption[] = [];
            productFamilCode?.value?.map((item) => {//NOSONAR
                let familyDes: ProductFamilyCodeOption = { ...item, valueCode: `${item.familyCode} - ${item.value}` };
                codeDesc = [...codeDesc, familyDes];
            });//NOSONAR
            familyCode = [...familyCode, ...codeDesc];
        });//NOSONAR
        if (familyCode?.length > 0) {
            Array.isArray(familyCode) &&
                familyCode.length > 0 &&
                familyCode.sort((a, b) => ((a.familyCode ?? "") > (b.familyCode ?? "") ? 1 : -1));
            setProductFamilyCode(familyCode);
        }
        setProdcutFilter(defaultValue ?? {});
        const getDivisionDefault =
            Array.isArray(productCategoryList?.data?.division) &&
            productCategoryList?.data?.division.filter(
                (e) =>
                    Array.isArray(defaultValue?.division) &&
                    defaultValue?.division.some((val) => val === e.key)
            );
        setDefaultDivision(
            Array.isArray(getDivisionDefault) ? getDivisionDefault : []
        );
        if (productDiv.current) {
            productDiv.current.state.selectedValues = Array.isArray(getDivisionDefault)
                ? getDivisionDefault
                : [];
        }
        const getDecsDefault =
            Array.isArray(category) &&
            category.filter(
                (e) =>
                    Array.isArray(defaultValue?.productCategoryDesc) &&
                    defaultValue?.productCategoryDesc.some((val) => val === e.key)
            );
        setDefaultProductCategoryDesc(
            Array.isArray(getDecsDefault) ? getDecsDefault : []
        );
        if (productCate.current) {
            productCate.current.state.selectedValues = Array.isArray(getDecsDefault)
                ? getDecsDefault
                : [];
        }
    }, [productCategoryList, defaultValue, modalOpen]);

    const addFamilyCode = () => {
        const selectedFamilyValues = productFam.current?.state?.selectedValues as ProductFamilyCodeOption[] | undefined;
        const defaultFamilyCodeBuket: string[] = Array.isArray(selectedFamilyValues)
            ? selectedFamilyValues.map((e) => String(e.familyCode))
            : [];
        const defaultDivisionKey = defaultDivision.map((e) => e.key);
        const defaultProductCategoryDescKey = defaultProductCategoryDesc.map(
            (e) => e.key
        );
        const defaultProductFamilyKey = defaultFamily.map(
            (e) => e.key
        );
        const productFilters: ProductFamilyFilter = {
            division: defaultDivisionKey,
            productCategoryDesc: defaultProductCategoryDescKey,
            producFamilyCode: defaultProductFamilyKey,
        };
        getFamilyCode(defaultFamilyCodeBuket, index, pIndex, productFilters);
        modalClose();
        setProductDivision([]);
        setProductCat([]);
        setProductFamilyCode([]);
    };

    const modalRefresh = () => {
        reset();
        modalClose();
        setProductDivision([]);
        setProductCat([]);
        setProductFamilyCode([]);
    };

    const handleCancel = (e: React.MouseEvent) => {
        reset();
        setProductDivision([]);
        setProductCat([]);
        setProductFamilyCode([]);
        e.preventDefault();
        modalClose();
    };

    const getProductDivision = (list: KeyValueOption[]) => {
        let division: number[] = [];
        let category: KeyValueOption[] = [];
        list?.map((item) => {//NOSONAR
            division = [...division, item.key];
            const categoryDesc = productCategoryList?.data?.productCategoryDesc?.find(
                (x) => x?.key === item.key
            );
            category = [...category, ...(categoryDesc?.value ?? [])];//NOSONAR
        });//NOSONAR
        const divi = { division: division };
        const filter = { ...productFilter, ...divi };
        setProdcutFilter(filter);
        Array.isArray(category) &&
            category.length > 0 &&
            category.sort((a, b) => (a.value > b.value ? 1 : -1));

        if (productDiv.current) {
            productDiv.current.state.selectedValues = list;
        }
        setDefaultDivision(list);
        const removeDefaultCatDec = category.filter(
            (e) =>
                Array.isArray(defaultProductCategoryDesc) &&
                defaultProductCategoryDesc.some(
                    (val) => val && e && val.key && e.key && val.key === e.key
                )
        );
        if (productCate.current) {
            productCate.current.state.selectedValues = removeDefaultCatDec;
        }
        setProductCat(category);
        setDefaultProductCategoryDesc(removeDefaultCatDec);
        getProductCat(removeDefaultCatDec);
    };

    const getProductCat = (list: KeyValueOption[]) => {
        let prodcutCat: number[] = [];
        let familyCode: ProductFamilyCodeOption[] = [];
        list?.map((item) => { //NOSONAR
            prodcutCat = [...prodcutCat, item.key];
            const productFamilCode = productCategoryList?.data?.productFamilyDesc?.find(
                (x) => x?.key === item.key
            );
            let codeDesc: ProductFamilyCodeOption[] = [];
            productFamilCode?.value?.map((item) => {//NOSONAR
                let familyDes: ProductFamilyCodeOption = { ...item, valueCode: `${item.familyCode} - ${item.value}` };
                codeDesc = [...codeDesc, familyDes];
            });//NOSONAR
            familyCode = [...familyCode, ...codeDesc];
        });//NOSONAR
        const cat = { productCategoryDesc: prodcutCat };
        const filter = { ...productFilter, ...cat };
        setProdcutFilter(filter);
        if (productCate.current) {
            productCate.current.state.selectedValues = list;
        }
        setDefaultProductCategoryDesc(list);
        Array.isArray(familyCode) &&
            familyCode.length > 0 &&
            familyCode.sort((a, b) => ((a.familyCode ?? "") > (b.familyCode ?? "") ? 1 : -1));
        const uniqueFinalFamilyCode = getUniqueListBy(familyCode, "familyCode");
        setProductFamilyCode(uniqueFinalFamilyCode);
    };

    const selectFamilyCode = () => {
        setTimeout(() => {
            setDefaultFamily([]);
        }, 10)
    };
    const removeFamilyCode = () => {
        // Preserved as a no-op: the legacy handler built a local productFamilyCode list
        // from the removed items but never used it for anything observable.
    };
    return (
        <Modal
            modalOpen={modalOpen}
            modalClose={modalRefresh}
            heading={productFamily && productFamily?.length > 0 ? "Edit Product Family Code" : "Select Product Family Code"}
            className={"modal_box"}
            modalSize={styles.custom_modal_size_family}
            reset={reset}
        >
            <div className={`pl-2 ${styles.patient_content} addFamily`}>
                <MultiSelect
                    id={"productDivision"}
                    name={"productDivision"}
                    label={`Product division:`}
                    classes={{
                        column: `col-12 ${styles.col_spec}`,
                        inputClassName: styles.basic_select,
                        labelClassName: `col-3 col-form-label ${styles.label_spec} onselect`,
                        inputColumn: `col-8 p-0 ${styles.select_wrapper}`,
                    }}
                    optionValue={productDivision}
                    displayValue="value"
                    showCheckbox={true}
                    onSelect={getProductDivision}
                    onRemove={getProductDivision}
                    defaultValue={Array.isArray(defaultDivision) ? defaultDivision : []}
                    validator={(e) => {
                        productDiv.current = e;
                    }}
                />
                <MultiSelect
                    id={"productCategoryDesc"}
                    name={"productCategoryDesc"}
                    label={`Product category description:`}
                    classes={{
                        column: `col-12 ${styles.col_spec}`,
                        inputClassName: styles.basic_select,
                        labelClassName: `col-3 col-form-label ${styles.label_spec} onselect`,
                        inputColumn: `col-8 p-0 ${styles.select_wrapper}`,
                    }}
                    optionValue={productCat}
                    displayValue="value"
                    showCheckbox={true}
                    onSelect={getProductCat}
                    onRemove={getProductCat}
                    defaultValue={Array.isArray(defaultProductCategoryDesc) ? defaultProductCategoryDesc : []}
                    validator={(e) => {
                        productCate.current = e;
                    }}
                />
                <MultiSelect
                    id={"producyFamily"}
                    name={"producyFamily"}
                    label={`Product family:`}
                    classes={{
                        column: `col-12 ${styles.col_spec}`,
                        inputClassName: styles.basic_select,
                        labelClassName: `col-3 col-form-label ${styles.label_spec} onselect`,
                        inputColumn: `col-8 p-0 ${styles.select_wrapper}`,
                    }}
                    optionValue={productFamilyCode}
                    displayValue="valueCode"
                    showCheckbox={true}
                    onSelect={selectFamilyCode}
                    onRemove={removeFamilyCode}
                    defaultValue={defaultFamily}
                    validator={(e) => {
                        productFam.current = e;
                    }}
                    closeOnSelect={false}
                />

                <div className="col-sm-12">
                    <div className="text-center pb-4">
                        <Button
                            classes={{
                                className: `btn ${styles.btn_custom} ${styles.btn_small}`,
                            }}
                            type="button"
                            id={SUBMIT_ID}
                            onClick={() => addFamilyCode()}
                        >
                            {SAVE_BTN}
                        </Button>
                        <Button
                            classes={{
                                className: `btn ${styles.btn_custom} ${styles.btn_small_cancel} handleCancel`,
                            }}
                            id={CANCEL_ID}
                            onClick={handleCancel}
                        >
                            {CANCEL_BTN}
                        </Button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};
